import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {PointByPointPointApiModel} from "./point-by-point.point.api-model";
import {PointByPointImportantPointDomainModel} from "../important-point/point-by-point.important-point.domain-model";
import {CompetitorDomainModel} from "../../../common/competitor/models/competitor-domain-model";

export class PointByPointPointDomainModel extends BaseDomainModel {
  apiModel: PointByPointPointApiModel;

  constructor(model: PointByPointPointApiModel, competitors: Map<Number, CompetitorDomainModel>) {
    super(model);

    this.competitors = competitors;
    this.score = model.score;
    this.winnerCompetitorId = model.winnerCompetitorId;
    this.importantPoint = model.importantPoint ? new PointByPointImportantPointDomainModel(model.importantPoint, competitors) : null;
    this.num = model.num;
  }

  get winnerCompetitor() {
    return this.competitors?.get(this.winnerCompetitorId) || null
  }
}
